module.exports = __webpack_public_path__ + "static/media/accessibility-b2b-round.dc5ae9d3.png";